import { ISortingModel } from "../../../../Common/models/grid";

export const defaultSorting = {
  field: "name",
  sort: "asc",
} as ISortingModel;
